import { Component, Injector, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
// import { , NgModule } from '@angular/core';
import type { OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { MyTimestampPipe } from '@shared/pipes';
import { TicketsService } from '@shared/services';
import { ViewBasePage } from '@shared/pages';
import type { TResponse, TTicket } from '@shared/models';

@Component({
    'selector': 'app-tickets',
    'templateUrl': './tickets.page.html',
    'styleUrls': ['./tickets.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, MyTimestampPipe ],
    'schemas': [CUSTOM_ELEMENTS_SCHEMA]
})
export class TicketsPage extends ViewBasePage implements OnInit, OnDestroy {
    public debugMode = false;
    public ticketsRef: any = {};
    public pendingTickets: TTicket[] = [];
    public assignedTickets: TTicket[] = [];
    public enrouteTickets: TTicket[] = [];
    public currentTickets: TTicket[] = [];
    public completedTickets: TTicket[] = [];
    private ticketsSubscription: any;

    // private popoverController: PopoverController,
    constructor(private ticketsService: TicketsService, 
        injector: Injector) {
        super(injector);
    }

    public ionViewWillEnter(): void {
        super.setCurrentView(this.Constants.VIEW_TICKETS);
    }

    public override ngOnInit(): void {
        super.ngOnInit();
        this.debugMode = this.sessionService.isDebugMode();

        const ticketsObservable = this.ticketsService.getObservable();
        this.ticketsSubscription = ticketsObservable.subscribe((tickets: TTicket[]) => {
            this.pendingTickets = tickets.filter((ticket: TTicket) => (ticket.status === 'pending'));
            this.assignedTickets = tickets.filter((ticket: TTicket) => (ticket.status === 'assigned'));
            this.enrouteTickets = tickets.filter((ticket: TTicket) => (ticket.status === 'enroute'));
            this.currentTickets = tickets.filter((ticket: TTicket) => (ticket.status === 'current'));

            // const today = this.dateService.parse('2022-07-07', 'yyyy-MM-dd');
            // const today = this.dateService.parse('2022-07-08', 'yyyy-MM-dd');
            const today = this.dateService.now();
            this.completedTickets = tickets.filter((ticket: TTicket) => {
                if (ticket.status !== 'completed' || !ticket.completedDate) {
                    return false;
                }
                const ticketCompletedToday = this.dateService.datesEqual(today, ticket.completedDate);
                return (ticketCompletedToday);
            });

            // It reads better if each ticket category is sorted by a different field.
            this.pendingTickets = this.ticketsService.sortPendingTickets(this.pendingTickets);
            this.assignedTickets = this.ticketsService.sortAssignedTickets(this.assignedTickets);
            this.enrouteTickets = this.ticketsService.sortEnrouteTickets(this.enrouteTickets);
            this.currentTickets = this.ticketsService.sortCurrentTickets(this.currentTickets);
            this.completedTickets = this.ticketsService.sortCompletedTickets(this.completedTickets);

            // Delete tickets that were completed before today
            /*            const ticketsCompletedBeforeToday = this.completedTickets.filter((ticket: TTicket) => {
                            const completedBeforeToday = this.dateService.isBeforeToday(ticket.completedDate);
                            return completedBeforeToday;
                        });
                        this.ticketsService.deleteTickets(ticketsCompletedBeforeToday);  
            */
        });

        this.initMoreMenu();
    }

    public override ngOnDestroy(): void {
        super.ngOnDestroy();
        // Make sure we remove all previous listeners.
        // if (this.disposable) {
        this.ticketsSubscription.unsubscribe();
        // }
    }

    public initMoreMenu(): void {
        this.pushPopoverMenuItem('Show Tour', 'show-tickets-tour');
    }

    public onTicketClick(uid: string): void {
        this.router.navigateByUrl(`tickets/ticket1Passenger/${uid}`);
    }

    public onTicketAdd(): void {
        this.router.navigateByUrl(`tickets/ticket1Passenger`);
    }

    public getType(ticket: TTicket) {
        const type = (ticket.fromDealership ? 'Dropoff' : 'Pickup');
        return type;
    }

    // public getLocationName(ticket: TTicket) {
    //     const locationName = (ticket.fromDealership ? ticket.dropoff.locationName : ticket.pickup.locationName);
    //     return locationName;
    // }

    public getLocationName(ticket: TTicket) {
        const locationName = (ticket.fromDealership ? ticket.dropoff?.locationName : ticket.pickup?.locationName);
        return locationName;
    }

    public getFullAddress(ticket: TTicket): string {
        const address = (ticket.fromDealership ? ticket.dropoff?.address : ticket.pickup?.address);
        return address.fullAddress;
    }

    public async onConfirmPrintTicket(ticket) {
        const question = 'Are you sure you want to print this ticket: ' + ticket.passengerName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Print', question);
        if (response.okay) {
            this.printTicket(ticket);
        }
    }

    public printTicket(ticket: TTicket) {
        // console.log('Printing ticket: ', ticket);
        // print the ticket
    }

    public async onConfirmDeleteTicket(ticket) {
        const question = 'Are you sure you want to delete ticket: ' + ticket.passengerName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Delete', question);
        if (response.okay) {
            await this.uxHelperService.showSpinner('Deleting.');
            await this.ticketsService.delete(ticket.uid);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Ticket was deleted.');
        }
    }

    public async onConfirmResetStatus(ticket) {
        const question = 'Are you sure you want to reset this ticket status back to pending: ' + ticket.passengerName + '?';
        const response = await this.uxHelperService.showAlert('Confirm Reset', question);   
        if (response.okay) {
            await this.uxHelperService.showSpinner('Reseting.');
            await this.ticketsService.setTicketToPending(ticket);
            await this.uxHelperService.hideSpinner();
            this.uxHelperService.showToast('Done.');
        }
    }
}
